import { useMemo, useState } from 'react';
import { contact } from '@/content/et/contact';
import { site } from '@/content/et/site';
import { isApplePlatform } from '@/lib/platform';

export type MapsCta = {
  href: string;
  label: string;
  isApple: boolean;
};

/** Platform-aware maps link + label (Apple Maps on iOS/Mac). */
export function getMapsCta(): MapsCta {
  const isApple = isApplePlatform();
  return {
    isApple,
    href: isApple ? contact.appleMapsUrl : contact.mapsUrl,
    label: isApple ? site.cta.directionsApple : site.cta.directions,
  };
}

/**
 * React hook — stable after first client render.
 * Defaults to Google on SSR; switches to Apple when detected.
 */
export function useMapsCta(): MapsCta {
  const [isApple] = useState(() => isApplePlatform());
  return useMemo(
    () => ({
      isApple,
      href: isApple ? contact.appleMapsUrl : contact.mapsUrl,
      label: isApple ? site.cta.directionsApple : site.cta.directions,
    }),
    [isApple],
  );
}
